(function ($) {
    var cardDependentModel = function (dependent, updateHeight, onSuccessCallback) {
        this.data = dependent;
        this.updateHeight = updateHeight;
        this.isOpened = ko.observable(false);

        this.onSuccessCallback = onSuccessCallback;
        if (!this.onSuccessCallback)
            this.onSuccessCallback = $.noop;

        this.fullName = ko.computed(function () {
            return ko.unwrap(this.data.FirstName) + " " + ko.unwrap(this.data.LastName);
        }.bind(this));

        this.requestCard = function () {
            $.cdh.helper.alert2({
                title: $.cdh.languageConstant.getConstant('profile.issue-new-debit-card-confirmation'),
                hasCloseBtn: true,
                message: $.cdh.languageConstant.getConstant(($.cdh.user.digitalCardConfig === "DigitalOnly" || $.cdh.user.digitalCardConfig === "DigitalWithMailOptional") ? "profile.issue-debit-card-for-digital" : "profile.issue-debit-card-for", { '0': this.fullName() }),
                okCallback: function () {
                    $.cdh.helper.waitAlert($.cdh.languageConstant.getConstant(($.cdh.user.digitalCardConfig === "DigitalOnly" || $.cdh.user.digitalCardConfig === "DigitalWithMailOptional") ? "profile.issue-debit-card-wait-message-digital" : "profile.issue-debit-card-wait-message", { '0': this.fullName() }));
                    var newCardRequest = new $.cdh.post.cards.new();
                    newCardRequest.load({ id: this.data.DependentId })
                        .done(function (data) {
                            $.cdh.helper.closePopup();
                            this.onSuccessCallback(data);

                            if ($.cdh.user.digitalCardConfig === "DigitalWithMailOptional") {
                                $.cdh.helper.alert2({
                                    title: $.cdh.languageConstant.getConstant('profile.issue-new-debit-card-confirmation'),
                                    hasCloseBtn: true,
                                    message: $.cdh.languageConstant.getConstant('cards.digital-card-withmail-message'),
                                    okText: $.cdh.languageConstant.getConstant('messages.yes'),
                                    cancelText: $.cdh.languageConstant.getConstant('messages.no'),
                                    okCallback: function () {
                                        $.cdh.helper.waitAlert($.cdh.languageConstant.getConstant('profile.issue-debit-card-wait-message', { '0': this.fullName() }));
                                        var updateCardRequest = new $.cdh.post.cards.update();
                                        updateCardRequest.load({
                                            CardProxyNum: data.CardProxyNumber
                                        })
                                            .done(function () {
                                                $.cdh.helper.closePopup();
                                                $.cdh.helper.alert(
                                                    $.cdh.languageConstant.getConstant('cards.physical-card-delivery-msg'),
                                                    null, null, $.cdh.languageConstant.getConstant("messages.success"));
                                            }.bind(this));
                                    }.bind(this),
                                    cancelCallback: function () {
                                        $.cdh.helper.closePopup();
                                        $.cdh.helper.alert(
                                            $.cdh.languageConstant.getConstant("cards.digital-card-issued-message", { '0': this.fullName() }),
                                            null, null, $.cdh.languageConstant.getConstant("messages.success"));
                                    }.bind(this)
                                });
                            } else {
                                $.cdh.helper.alert($.cdh.languageConstant.getConstant(
                                    $.cdh.user.digitalCardConfig === "DigitalOnly"
                                        ? "cards.digital-card-issued-message"
                                        : "profile.debit-card-issued-successfully-for",
                                    { '0': this.fullName() }
                                ), null, null, $.cdh.languageConstant.getConstant("messages.success"), null, null);
                            }
                        }.bind(this))
                        .fail(function (resp) {
                            $.cdh.helper.closePopup();
                            $.cdh.helper.alert(resp.responseJSON.message, null, null, $.cdh.languageConstant.getConstant("profile.falied-to-issue-card"));
                        });
                }.bind(this),
                okText: $.cdh.languageConstant.getConstant('profile.issue-card')
            });
        }.bind(this);
        var breakPoint = 768
        this.openCard = function () {
            if (window.innerWidth < breakPoint) {
                this.isOpened(!this.isOpened());
            }      
        }.bind(this);

        this.cardRowKeyDown = cardRowKeyDown;
        function cardRowKeyDown(card, e) {
            if (window.innerWidth < breakPoint && (e.keyCode === 32 || e.keyCode === 13)) {
                this.isOpened(!this.isOpened());
                return false;
            }
            return true;
        };



    };


    
    $.extend(true, $, {
        cdh: {
            models: {
                CardDependent: cardDependentModel
            }
        }
    });

})(jQuery);